import { ContactFormData } from '../../../common/activities/contact-forms/facade/contact-form';
import { requestApiWithError } from '../common/fetchers/fetch-with-error';

export async function postContactForm(data: ContactFormData) {
  return await requestApiWithError<{ status: 'ok' }>(`/contact-form`, 'POST', data);
}
